@if (building) {
<div class="address">
  @if (building.name) {
  <p
    class="building-name"
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[building.name]"
  >
    {{ building.name }}
  </p>
  }
  <p
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[building.location.streetAddress]"
  >
    {{ building.location.streetAddress }}
  </p>
  <p
    wmFrontTooltip="data"
    position="top"
    [offset]="-15"
    [onlyOnOverflow]="true"
    [data]="[
      building.location.zipcode,
      (building.location.city?.name ?? '')
    ]"
  >
    {{ building.location.zipcode }}
    {{ building.location.city?.name }}
  </p>
</div>
} @else { --- }
